/*
** Import the SDK
*/

import firebase from 'firebase/app'
import firestore from 'firebase/firestore'
import auth from 'firebase/auth'
import storage from 'firebase/storage'

/*
** Set the Firebase config variables
*/

let firebaseNestdConfig = {

	apiKey: String(process.env.VUE_APP_FIREBASE_API_KEY),
	authDomain: String(process.env.VUE_APP_FIREBASE_AUTH_DOMAIN),
	databaseURL: String(process.env.VUE_APP_FIREBASE_DATABASE_URL),
	projectId: String(process.env.VUE_APP_FIREBASE_PROJECT_ID),
	storageBucket: String(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET),
	messagingSenderId: String(process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID),
	appId: String(process.env.VUE_APP_FIREBASE_APP_ID),

};

/*
** Initialize Firebase in apps
*/

const nestdApp = firebase.initializeApp(firebaseNestdConfig);

/*
** Export the Nestd individual services
*/

export const firestoreDB = nestdApp.firestore();
export const firebaseAuth = nestdApp.auth();
export const firebaseStorage = nestdApp.storage();

/*
** Export the Nestd models
*/

export const configModel = firestoreDB.collection('config');
export const usersModel = firestoreDB.collection('users');
export const propertiesModel = firestoreDB.collection('properties');
export const companiesModel = firestoreDB.collection('companies');
export const residentsModel = firestoreDB.collection('residents');
export const emailsModel = firestoreDB.collection('emails');
export const paymentIntentsModel = firestoreDB.collection('payment_intents');
export const articlesModel = firestoreDB.collection('articles');
export const policiesModel = firestoreDB.collection('policies');
export const supportCategoriesModel = firestoreDB.collectionGroup('support');
export const invoicesModel = firestoreDB.collectionGroup('invoices');
export const rentsModel = firestoreDB.collectionGroup('rents');
export const invoiceEventsModel = firestoreDB.collectionGroup('events');
export const unitsModel = firestoreDB.collectionGroup('units');